import { createApp } from "vue";
import { attachSentryToApp } from "@Plugins/sentry";
import i18n from '@Plugins/localization';
import { QueryClient, VueQueryPlugin } from "@tanstack/vue-query";
import { createPinia } from "pinia";

export const mountTemplates = async () => {
    const templates = document.querySelectorAll('[data-template]');
    const pinia = createPinia();
    const queryClient = new QueryClient();

    templates.forEach(async (template) => {
        const templateUrl = template.getAttribute('data-template');
        const cssUrl = template.getAttribute('data-css-url');
        const queryUrl = template.getAttribute('data-query-url');
        const scriptUrl = template.getAttribute('data-script-url');

        const { default: RuntimeTemplate } = await import(`./RuntimeTemplate.vue`);
        const templateWrapper = createApp(RuntimeTemplate, {
            templateUrl,
            cssUrl,
            queryUrl,
            scriptUrl
        });
        templateWrapper.use(pinia);
        templateWrapper.use(VueQueryPlugin, { queryClient });
        templateWrapper.use(i18n);
        attachSentryToApp(templateWrapper);
        templateWrapper.mount(template);
    });
};